/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: dialProfilesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Dial Profiles module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteDialProfile } from './api';

/**
 * Shared helpers for Dial Profiles module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Dial Profile in the form.
 * Pattern: /settings/technology/dial-profile/new?duplicate={id} or /pbx/applications/dial-profiles/new?duplicate={id}
 */
export const getDialProfileDuplicateUrl = (id: string | number, isSettingsContext: boolean = false): string => {
  const basePath = isSettingsContext 
    ? '/settings/technology/dial-profile' 
    : '/pbx/applications/dial-profiles';
  return `${basePath}/new?duplicate=${id}`;
};

/**
 * Navigate to the form in duplicate mode for the given Dial Profile id.
 */
export const navigateToDialProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
  isSettingsContext: boolean = false,
): void => {
  navigate(getDialProfileDuplicateUrl(id, isSettingsContext));
};

/**
 * Low-level API helper to delete a Dial Profile by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteDialProfile from './api' instead
 */
export const deleteDialProfileById = async (id: string | number): Promise<void> => {
  await deleteDialProfile(id);
};











